import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { IconComponent } from '../icon/icon.component';
import { MarmonIconType } from '../icon/icons.const';

@Component({
	standalone: true,
	imports: [IconComponent, TranslocoPipe],
	selector: 'mar-section-header',
	templateUrl: 'section-header.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: { class: 'flex flex-col gap-4' },
})
export class SectionHeaderComponent {
	label = input<string | { text: string; translate: boolean }>();
	description = input<string>();

	icon = input<MarmonIconType | undefined>();
}
